module.exports = __webpack_public_path__ + "img/clipboard.653e9dde.svg";